import { useEffect, useState } from "react";
import "./SettingSubscription.css";

//svg images started
import { CardElement, useElements, useStripe } from "@stripe/react-stripe-js";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import checkmark from "../../../Assets/images/checkmark.svg";
import { API_URL } from "../../../server";
import { Modal } from "react-bootstrap";
//svg images ended

const SettingSubscription = ({ subscriptionModal, setSubscriptionModal }) => {
  const [subscriptionDetails, setSubscriptionDetails] = useState([]);
  const registerid = sessionStorage.getItem("registerid");
  const [errorModule, setErrorModule] = useState(false);
  const [loader, setLoader] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [userDetails, setUserDetails] = useState(null);
  const [nextRenewalDate, setNextRenewalDate] = useState(null);

  const stripe = useStripe();
  const elements = useElements();
  const [error, setError] = useState(null);
  const [isProcessing, setIsProcessing] = useState(false);

  const token = sessionStorage.getItem("token");
  const navigate = useNavigate();

  useEffect(() => {
    getadminsubscriptionprice();
    mydetails();
  }, []);

  const currencySymbols = {
  GBP: "£",
  USD: "$",
  EUR: "€",
  AUD: "A$"
};



  const paymentintent = () => {
    const registerid = sessionStorage.getItem("registerid");
    const customerId = sessionStorage.getItem("customerId");

    setLoader(true);
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    const raw = JSON.stringify({
      customerId: customerId,
      amount: subscriptionDetails?.subscriptionPrice * 100,
      currency: subscriptionDetails?.currency?.toLocaleUpperCase(),
      sessionCount: 1,
      user_id: registerid,
    });

    console.log("requestOptionsraw", raw);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };
    fetch(API_URL + "createPaymentIntent", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("createPaymentIntent", result);
        if (result.success == true) {
          handleSubmit(result?.paymentIntent.client_secret);
          mydetails();
          setLoader(false);
        } else {
          setErrorMsg(result.error);
          setErrorModule(true);
          setLoader(false);
        }
      })
      .catch((error) => console.error(error))
      .finally(() => {
        setLoader(false);
      });
  };
  const handleSubmit = async (client_secret) => {
    if (!stripe || !elements) {
      console.error("Stripe has not loaded yet.");
      return;
    }
    setIsProcessing(true);
    const cardElement = elements.getElement(CardElement);
    try {
      const { paymentIntent, error } = await stripe.confirmCardPayment(
        client_secret, // Replace with your actual client secret
        {
          payment_method: {
            card: cardElement,
          },
        },
      );
      if (error) {
        setError(error.message);
        console.error("Payment failed:", error.message);
      } else if (paymentIntent && paymentIntent.status === "succeeded") {
        console.log("Payment succeeded:", paymentIntent);
        addfreesubscription(registerid);
      }
    } catch (err) {
      toast.success(err.message);
      console.error("Error during payment processing:", err.message);
    }
  };
  const getadminsubscriptionprice = () => {
    const myHeaders = new Headers();
    myHeaders.append("Authorization", "Bearer " + token);

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      redirect: "follow",
    };

    fetch(API_URL + "getAdminSubscriptionPrice", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("getAdminSubscriptionPrice", result);
        setSubscriptionDetails(result.data[0]);
      })
      .catch((error) => console.error(error));
  };

  const currency =
  currencySymbols[subscriptionDetails?.currency] || "$";

  const cancelSubscription = () => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  myHeaders.append("Authorization", "Bearer " + token);

  const raw = JSON.stringify({
    user_id: registerid,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
    redirect: "follow",
  };

  fetch(API_URL + "deletePremiumSubscription", requestOptions)
    .then((response) => response.json())
    .then((result) => {
      console.log("deletePremiumSubscription", result);

      if (result.Status === true) {
        toast.success(result.message);

        mydetails(); // refresh data
        setSubscriptionModal(false); // <-- ADD HERE
      } else {
        toast.error(result.message);
      }
    })
    .catch((error) => console.error(error));
};


  // const cancelSubscription = () => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", "Bearer " + token);

  //   const raw = JSON.stringify({
  //     user_id: registerid,
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(API_URL + "deletePremiumSubscription", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log("deletePremiumSubscription", result);

  //       if (result.Status === true) {
  //         toast.success(result.message);

  //         // refresh user details so UI updates
  //         mydetails();
  //       } else {
  //         toast.error(result.message);
  //       }
  //     })
  //     .catch((error) => console.error(error));
  // };

  const mydetails = () => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({ _id: registerid });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "getUsers", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("getUsers", result);
        setUserDetails(result.data);

        // ⬇ Extract nextRenewalDate here correctly
        const renewalDate = result?.data?.profile?.nextRenewalDate;
        if (renewalDate) {
          // const formatted = new Date(renewalDate).toLocaleDateString("en-US", {
          //   year: "numeric",
          //   month: "long",
          //   day: "numeric",
          // });
          const dateObj = new Date(renewalDate);

          const day = String(dateObj.getDate()).padStart(2, "0");
          const month = dateObj.toLocaleString("en-US", { month: "long" });
          const year = dateObj.getFullYear();

          const formatted = `${day} ${month} ${year}`;
          setNextRenewalDate(formatted);

          setNextRenewalDate(formatted);
        } else {
          setNextRenewalDate(null);
        }
      })
      .catch((error) => console.error(error));
  };

  // const mydetails = () => {
  //   const myHeaders = new Headers();
  //   myHeaders.append("Content-Type", "application/json");
  //   myHeaders.append("Authorization", "Bearer " + token);

  //   const raw = JSON.stringify({
  //     _id: registerid,
  //   });

  //   const requestOptions = {
  //     method: "POST",
  //     headers: myHeaders,
  //     body: raw,
  //     redirect: "follow",
  //   };

  //   fetch(API_URL + "getUsers", requestOptions)
  //     .then((response) => response.json())
  //     .then((result) => {
  //       console.log("getUsers", result);
  //       setUserDetails(result.data);
  //     })
  //     .catch((error) => console.error(error));
  // };

  const addfreesubscription = (regid) => {
    const myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");
    myHeaders.append("Authorization", "Bearer " + token);

    const raw = JSON.stringify({
      user_id: regid,
    });

    const requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    fetch(API_URL + "addPremiumSubscription", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        console.log("addPremiumSubscription", result);
        if (result.Status == true) {
          toast.success(result.message, {
            onClose: () => {
              mydetails();
              navigate("/SettingsMainScreen/SettingNameScreen");
            },
          });
        } else {
          toast.error(result.message);
        }
      })
      .catch((error) => console.error(error));
  };

  return (
    <Modal
      centered
      show={subscriptionModal}
      onHide={() => setSubscriptionModal(false)}
      className="flex items-center m-0 rad"
    >
      <Modal.Body className="modalbackgroundcolor  p-4 items-center rounded-lg">
        <div>
          <div className="d-flex justify-content-end">
            <button
              className="btn-close"
              onClick={() => setSubscriptionModal(false)}
            ></button>
          </div>

          <h5 className="heading mb-3">
            {userDetails?.profile?.subscription
              ? "You’re Subscribed"
              : "Unlock Full Access"}
          </h5>
          <p className="para">
            {userDetails?.profile?.subscription
              ? " You have access to personalised learning, real-world tasks, and AI-powered support."
              : " Get full access to personalised learning, real-world tasks, and AI-powered support."}
          </p>

          {/* Benefits */}
          <div className="d-flex align-items-center gap-3 mt-4">
            <img src={checkmark} />
            <span className="para">
              Learn through structured courses with interactive Loops
            </span>
          </div>
          <div className="d-flex align-items-center gap-3 mt-2">
            <img src={checkmark} />
            <span className="para">
              Chat with expertly trained subject-specific AI tutors anytime
            </span>
          </div>
          <div className="d-flex align-items-center gap-3 mt-2">
            <img src={checkmark} />
            {/* <span className="para">
              Work on employer challenges through the industry portal
            </span> */}
            <span className="para">
              Apply your skills through practical projects and challenges
            </span>
          </div>
          <div className="d-flex align-items-center gap-3 mt-2">
            <img src={checkmark} />
            <span className="para">
              Access curated resources, tools, and templates for each subject
            </span>
          </div>

          {/* Payment section */}
          <div className="mb-4">
            {userDetails?.profile?.subscription === false ? (
              <div>
                <h6 className="text-muted mb-4 mt-4">
                  Enter your card details below
                </h6>
                <CardElement className="card-element" />
                <hr />
                <button
                  onClick={paymentintent}
                  className="subbutton subspan mt-3"
                  disabled={isProcessing}
                >
                  {isProcessing
                    ? "Processing..."
                    // : `Join now for $${subscriptionDetails?.subscriptionPrice}`}
                    : `Join now for ${currency}${subscriptionDetails?.subscriptionPrice}`}
                </button>
              </div>
            ) : (
              <>
                {/* <p className="copara mt-4">
                  <strong>Next renewal date: 29 August 2026</strong>
                </p> */}
                {userDetails?.profile?.subscription && nextRenewalDate && (
                  <p className="copara mt-4">
                    <strong>Next renewal dates: {nextRenewalDate}</strong>
                  </p>
                )}

                {/* <button className="btn btn-dark w-100 mt-4">
                  Cancel subscription
                </button> */}

                <button
                  className="btn btn-dark w-100 mt-4"
                  onClick={cancelSubscription}
                >
                  Cancel subscription
                </button>
              </>
            )}
          </div>

          {/* Info text */}
          {userDetails?.profile?.subscription ? (
            // <p className='subpara lh-base text-muted mt-3'>
            //   Need help? You can always{' '}
            //   <span style={{ textDecoration: 'underline', cursor: 'pointer' }}>
            //     Contact Support
            //   </span>
            //   .
            // </p>
            <div className="text-center mt-4">
              <p className="text-muted fw-medium mb-0">
                Need help? You can always{" "}
                <a
                  href="https://mail.google.com/mail/?view=cm&fs=1&to=hello@recess.education"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="fw-medium text-neutral-900 underline hover:text-gray-500 transition-colors duration-200"
                >
                  Contact Support.
                </a>
                {/* <span
                  className='fw-medium text-muted'
                  style={{ textDecoration: 'none' }}
                >
                  {' '}
                  for further help
                </span> */}
              </p>
            </div>
          ) : (
            <p className="subpara lh-base text-muted text-center">
              You can also ask your school, university, or employer to <br />
              {/* <span style={{ textDecoration: 'underline' }}>
                support your learning on Recess.
              </span> */}
              <a
                href="https://www.recess.education/institutions"
                target="_blank"
                rel="noopener noreferrer"
                style={{ textDecoration: "underline", color: "inherit" }}
              >
                support your learning on Recess.
              </a>
            </p>
          )}
        </div>
      </Modal.Body>
    </Modal>
  );
};
export default SettingSubscription;

//  <div style={{ maxWidth: '531px' }}>
//       <div>
//         {loader && (
//           <div className='loader-backdrop'>
//             <div className='loader'></div>
//           </div>
//         )}
//       </div>
//       <div style={{ maxWidth: '531px' }}>
//         <h5 className='heading'>Recess Pathway</h5>
//         <p className='para'>Join Recess Pathway and jumpstart your career.</p>
//         <div>
//           <div>
//             <div className='d-flex align-items-center gap-3 mt-4'>
//               <span>
//                 <img className='subscribeimg' src={develop} />
//               </span>
//               <span className='copara'>
//                 Develop in-demand skills through{' '}
//                 <strong>structured courses and certifications.</strong>
//               </span>
//             </div>
//             <div className='d-flex align-items-center gap-3 mt-2'>
//               <span>
//                 <img className='subscribeimg' src={build} />
//               </span>
//               <span className='copara'>
//                 Build a standout resume with our{' '}
//                 <strong>AI-powered resume builder</strong>{' '}
//                 <span className='text-muted'>(on its way)</span>
//               </span>
//             </div>
//             <div className='d-flex align-items-center gap-3 mt-2'>
//               <span>
//                 <img className='subscribeimg' src={contribute} />
//               </span>
//               <span className='copara'>
//                 Contribute to real-world employer tasks through our industry
//                 portal <span className='text-muted'>(on its way)</span>
//               </span>
//             </div>
//             <div className='d-flex align-items-center gap-3 mt-2'>
//               <span>
//                 <img className='subscribeimg' src={enjoy} />
//               </span>
//               <span className='copara'>
//                 Enjoy resource partner discounts on{' '}
//                 <strong>tools, supplies, and more.</strong>
//               </span>
//             </div>
//           </div>
//         </div>
//         <div className='mb-5'>
//           {userDetails?.profile?.subscription == false ? (
//             <div>
//               <div className='mt-4'>
//                 <h6 className='text-muted mb-4'>
//                   Enter your card details below
//                 </h6>
//                 <CardElement className='card-element' />
//                 <hr />
//                 {/* <PaymentElement/> */}
//               </div>
//               <button
//                 onClick={paymentintent}
//                 className='subbutton subspan mt-3'
//               >
//                 Join now for ${subscriptionDetails?.subscriptionPrice}
//               </button>
//             </div>
//           ) : (
//             <hr style={{ marginBottom: '-50px' }} />
//           )}
//         </div>
//         <p className='subpara lh-base text-muted' style={{ marginTop: '20%' }}>
//           You may see a holding charge as we pre-authorise your payment method.
//           Don't worry, you won't actually be charged for this pre-authorisation.
//         </p>
//         <p className='subpara lh-base text-muted'>
//           Your free 60-day subscription begins today. After 60 days, you will
//           automatically be charged $19 per month going forward. Cancel anytime.
//         </p>
//       </div>
//     </div>
